import {useState} from 'react';
import {useMediaPreview} from '../../lib/media';

export function safeWebUrl(value?:string|null){
 try{const url=new URL(value||'');return ['http:','https:'].includes(url.protocol)?url.href:undefined}catch{return undefined}
}

/** Each mounted image owns its authenticated Blob preview and cleanup. */
export function PrivateSocialImage({mediaId,index=0}:{mediaId:string;index?:number}){
 const preview=useMediaPreview(mediaId),[failed,setFailed]=useState(false);
 return preview.url&&!failed?<img className="cover-preview" src={preview.url} alt={`Billede ${index+1} i opslag`} onError={()=>setFailed(true)}/>:<p className="muted" role="status">{preview.loading?'Henter billede…':preview.error?'Billedet kunne ikke hentes. Vedhæftningen er bevaret.':'Billedet er ikke tilgængeligt.'}</p>;
}

export function ExternalSocialImage({url,index}:{url:string;index:number}){
 const[failed,setFailed]=useState(false),src=safeWebUrl(url);
 return src&&!failed?<img className="cover-preview" src={src} alt={`Billede ${index+1} i opslag`} referrerPolicy="no-referrer" onError={()=>setFailed(true)}/>:<p className="muted">Det importerede billede er ikke længere tilgængeligt.</p>;
}

